declare namespace $ {

	export class $bog_card_particles extends $mol_view {
		Particle1( ): $mol_view
		Particle2( ): $mol_view
		Particle3( ): $mol_view
		Particle4( ): $mol_view
		Particle5( ): $mol_view
		Particle6( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=particles.view.tree.d.ts.map